export default "__VITE_ASSET__CYyQYCGW__"